import React, { useState, useEffect, useMemo } from "react";
import "@styles/pages/GenericPage/VideoBlogSummaryPage/VideoBlogSummaryPage.scss";
import { getVideoList, getBlogList } from "@api/landingApi";
import { getOptionData } from "@api/commonApi";
import {
  videoFilterData,
  blogFilterData,
  genericLatestPopularFilterData,
} from "@data/FilterData";
import SummaryCardList from "@pages/GenericPage/VideoBlogSummaryPage/SummaryCardList";
import { Box, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

const VideoBlogSummaryPage = () => {
  const { t, i18n } = useTranslation();
  const isChinese = i18n.language === "hk";

  const [currentStep, setCurrentStep] = useState(0);
  const [videoCardList, setVideoCardList] = useState([]);
  const [blogCardList, setBlogCardList] = useState([]);
  const [videoFilterOptions, setVideoFilterOptions] = useState({});
  const [blogFilterOptions, setBlogFilterOptions] = useState({});

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const section = query.get("section");

    if (section === "blog") {
      setCurrentStep(1);
    }
  }, [location.search]);

  // ✅ 預組裝 filterList，加入 static filter
  const combinedVideoFilterList = useMemo(() => [...videoFilterData], []);

  const combinedBlogFilterList = useMemo(() => [...blogFilterData], []);

  const fetchVideoList = async () => {
    try {
      const res = await getVideoList();
      setVideoCardList(res.data.Data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchBlogList = async () => {
    try {
      const res = await getBlogList();
      setBlogCardList(res.data.Data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchAllOptions = async (filterList, type) => {
    const result = {};

    for (const filter of filterList) {
      try {
        if (filter.staticOptions) {
          result[filter.type] = filter.staticOptions;
          continue;
        }

        const res = await getOptionData({ type: filter.type });
        result[filter.type] = res?.data?.Data || [];
      } catch (err) {
        console.error("Failed to fetch", filter.type, err);
      }
    }

    if (type === "video") setVideoFilterOptions(result);
    if (type === "blog") setBlogFilterOptions(result);
  };

  useEffect(() => {
    fetchVideoList();
    fetchBlogList();
    fetchAllOptions(combinedVideoFilterList, "video");
    fetchAllOptions(combinedBlogFilterList, "blog");
  }, []);

  return (
    <Box className="video-blog-summary-page-container">
      <Box className="title-container">
        <Typography
          className={`title ${currentStep === 0 ? "active" : ""}`}
          onClick={() => setCurrentStep(0)}
        >
          <Trans i18nKey="generic:latest_video" />
        </Typography>
        <Typography
          className={`title ${currentStep === 1 ? "active" : ""}`}
          onClick={() => setCurrentStep(1)}
        >
          <Trans i18nKey="generic:blog" />
        </Typography>
      </Box>

      {currentStep === 0 && (
        <SummaryCardList
          cardType="video"
          filterData={combinedVideoFilterList}
          filterOptions={videoFilterOptions}
          cardList={videoCardList}
        />
      )}
      {currentStep === 1 && (
        <SummaryCardList
          cardType="blog"
          filterData={combinedBlogFilterList}
          filterOptions={blogFilterOptions}
          cardList={blogCardList}
        />
      )}
    </Box>
  );
};

export default VideoBlogSummaryPage;
